import {
  getQueryParam,
  removeURLParameter,
} from './urlHelper';

export const getAndSetUtmParameters = () => {
  let urlWithoutUtm = window.location.href;
  if (getQueryParam('utm_source')) {
    global.window.localStorage.setItem('utm_source', getQueryParam('utm_source'));
    urlWithoutUtm = removeURLParameter(urlWithoutUtm, 'utm_source');
  }
  if (getQueryParam('utm_medium')) {
    global.window.localStorage.setItem('utm_medium', getQueryParam('utm_medium'));
    urlWithoutUtm = removeURLParameter(urlWithoutUtm, 'utm_medium');
  }
  if (getQueryParam('utm_campaign')) {
    global.window.localStorage.setItem('utm_campaign', getQueryParam('utm_campaign'));
    urlWithoutUtm = removeURLParameter(urlWithoutUtm, 'utm_campaign');
  }
  if (getQueryParam('utm_term')) {
    global.window.localStorage.setItem('utm_term', getQueryParam('utm_term'));
    urlWithoutUtm = removeURLParameter(urlWithoutUtm, 'utm_term');
  }
  if (getQueryParam('utm_content')) {
    global.window.localStorage.setItem('utm_content', getQueryParam('utm_content'));
    urlWithoutUtm = removeURLParameter(urlWithoutUtm, 'utm_content');
  }

  if (urlWithoutUtm !== window.location.href) {
    window.history.pushState({ path: urlWithoutUtm }, '', urlWithoutUtm);
  }
};

export const removeLocalstorageUtmParameters = () => {
  global.window.localStorage.removeItem('utm_source');
  global.window.localStorage.removeItem('utm_medium');
  global.window.localStorage.removeItem('utm_campaign');
  global.window.localStorage.removeItem('utm_term');
  global.window.localStorage.removeItem('utm_content');
  global.window.localStorage.removeItem('signup_request');
};
